<template>
  <div
    v-if="store.state.MenuStore.openMenu"
    class="fixed w-full font-medium flex pt-[50px] h-screen z-10"
  >
    <div
      :class="store.state.MenuStore.openMenu ? '' : 'hidden'"
      class="w-[65%] bg-white"
    >
      <transition
        enter-active-class="transition-transform duration-500"
        leave-active-class="transition-transform duration-500"
      >
        <div
          v-if="store.state.MenuStore.openMenu"
          class="flex transform translate-x-0 flex-col"
        >
          <router-link
            @click="toggleMenu"
            to="/license-plate"
            :class="activePage('license-plate') ? '' : ''"
            class="w-full flex items-center h-13 border-b-[1px] px-5 py-3"
          >
            <label for="license_plate" class="pt-2"
              >{{ $t("account.license_plate") }}:
              <b>{{ store.state.user.data.license_plate }}</b>
            </label>
          </router-link>
          <router-link
            @click="toggleMenu"
            to="/profile"
            :class="activePage('profile') ? '' : ''"
            class="w-full flex items-center h-13 border-b-[1px] px-5 py-3"
          >
            {{ $t("account.your_account") }}
          </router-link>
          <LocaleChanger />
          <div class="w-full flex items-center h-13 px-5 py-3">
            <a
              href=""
              class="font-weight-light text-decoration-none text-black"
              @click="logout"
            >
              Logout
            </a>
          </div>
        </div>
      </transition>
    </div>
    <div
      @click.prevent="toggleMenu"
      v-if="store.state.MenuStore.openMenu"
      :class="store.state.MenuStore.openMenu ? '' : 'hidden'"
      class="w-[35%] opacity-50 bg-coolGrey200"
    ></div>
  </div>
</template>
<script setup>
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
import firebaseAuthService from "@/services/FirebaseAuthService";
import LocaleChanger from "@/components/LocaleChanger";

const toggleMenu = () => {
  store.dispatch("MenuStore/toggleMenu");
};
const route = useRoute();
const router = useRouter();

const activePage = (page) => {
  return route.name === page;
};
const logout = async () => {
  await firebaseAuthService.logout();
  router.push("/login");
};
</script>
